import { apiRequest } from '@/utils/api-request';

export interface RunSession {
  session_id: string;
  session_socket_url: string;
}

export const getRunSession = async () => {
  const response = await apiRequest<RunSession>({
    url: '/session/create-session',
    method: 'GET',
    target: 'workflow',
  });
  return response.data;
};
